import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { Grid, IconButton } from "@material-ui/core";
import { DateRange } from "@material-ui/icons";
import ClearIcon from "@material-ui/icons/Clear";
import { DateRangePickerDialog } from "./DateRangePickerDialog";
import { staticRanges } from "../constants/staticDateRanges";

/**
 * Date range controls for charts with reset functionality
 */
export const ChartDateRangeControls = ({
  selectionRange,
  onRangeChange,
  openDialog,
  onOpenDialog,
  onReset,
}) => {
  return (
    <Grid item xs={12}>
      <div style={{ textAlign: "right" }}>
        <IconButton onClick={onReset}>
          <ClearIcon />
        </IconButton>
        From {moment(selectionRange.startDate).format("MM/DD/YYYY")} to{" "}
        {moment(selectionRange.endDate).format("MM/DD/YYYY")}
        <IconButton onClick={() => onOpenDialog(true)}>
          <DateRange />
        </IconButton>
      </div>
      <DateRangePickerDialog
        open={openDialog}
        onClose={() => onOpenDialog(false)}
        selectionRange={selectionRange}
        onChange={onRangeChange}
        staticRanges={staticRanges}
        retainEndDateOnFirstSelection={true}
      />
    </Grid>
  );
};

ChartDateRangeControls.propTypes = {
  selectionRange: PropTypes.object.isRequired,
  onRangeChange: PropTypes.func.isRequired,
  openDialog: PropTypes.bool.isRequired,
  onOpenDialog: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
};

